import { useForm } from '@inertiajs/react'
import AuthLayout from '../../components/AuthLayout'
import Heading from '@arianna/design-system/Heading'
import Text from '@arianna/design-system/Text'
import Input from '@arianna/design-system/Input'
import Button from '@arianna/design-system/Button'

interface Props {
  reset_password_token: string
  errors: Record<string, string>
  flash: Record<string, string>
}

export default function ResetPassword({ reset_password_token, errors, flash }: Props) {
  const form = useForm({
    password: '',
    password_confirmation: '',
    reset_password_token,
  })

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    form.put('/users/password', { forceFormData: false })
  }

  const allErrors = { ...errors, ...form.errors }

  return (
    <AuthLayout>
      <Heading variant="h3" style={{ marginBottom: 'var(--space-1)' }}>
        Nuova password
      </Heading>
      <Text
        variant="body"
        style={{ color: 'var(--ink-3)', display: 'block', marginBottom: 'var(--space-6)' }}
      >
        Scegli una nuova password per il tuo account.
      </Text>

      {flash.notice && (
        <div
          style={{
            background: 'color-mix(in oklab, var(--accent) 10%, transparent)',
            border: '1px solid var(--accent)',
            borderRadius: 'var(--radius-sm)',
            padding: 'var(--space-3)',
            marginBottom: 'var(--space-4)',
          }}
        >
          <Text variant="meta" style={{ color: 'var(--accent)', fontSize: 13 }}>
            {flash.notice}
          </Text>
        </div>
      )}

      {Object.keys(allErrors).length > 0 && (
        <div
          style={{
            background: 'color-mix(in oklab, var(--red) 10%, transparent)',
            border: '1px solid var(--red)',
            borderRadius: 'var(--radius-sm)',
            padding: 'var(--space-3)',
            marginBottom: 'var(--space-4)',
          }}
        >
          {Object.entries(allErrors).map(([field, msg]) => (
            <Text key={field} variant="meta" as="div" style={{ color: 'var(--red)', fontSize: 13 }}>
              {field !== 'base' ? `${field}: ` : ''}
              {msg}
            </Text>
          ))}
        </div>
      )}

      <form
        onSubmit={handleSubmit}
        style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-4)' }}
      >
        <input type="hidden" name="reset_password_token" value={reset_password_token} />
        <Input
          label="Nuova password"
          type="password"
          autoComplete="new-password"
          value={form.data.password}
          onChange={(e) => form.setData('password', e.target.value)}
          required
        />
        <Input
          label="Conferma password"
          type="password"
          autoComplete="new-password"
          value={form.data.password_confirmation}
          onChange={(e) => form.setData('password_confirmation', e.target.value)}
          required
        />
        <Button
          type="submit"
          variant="primary"
          size="md"
          disabled={form.processing}
          style={{ width: '100%' }}
        >
          {form.processing ? 'Salvataggio…' : 'Imposta nuova password'}
        </Button>
      </form>
    </AuthLayout>
  )
}
